import { SearchStoreState } from '~/domain/interfaces/SearchTypes'

export default {
    setTerm(state: SearchStoreState, term) {
      state.term = term
    },
    setFilter(state: SearchStoreState, filter) {
      state.filter = filter
    },
    clearSearch(state: SearchStoreState) {
      state.term = ''
    }
  }